import React from "react";
import { useNavigate } from "react-router";
import { useLocation, useParams } from "react-router-dom";

export const withRouter = (Component) => {
  return (props) => {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    return (
      <Component
        navigate={navigate}
        params={params}
        location={location}
        {...props}
      />
    );
  };
};
